import { axiosService } from "@/services/AxiosService";



/**
 * @typedef {Object} HorseVaccine
 * @property {number} id - ID del record della vaccinazione
 * @property {number} horse_id - ID del cavallo associato
 * @property {string} vaccine_id - ID del vaccino somministrato
 * @property {string} date - Data di somministrazione del vaccino
 * @property {string} expiration - Data di scadenza del vaccino
 * @property {boolean} done - Stato della vaccinazione (completata o meno)
 * @property {string} modified - Data di modifica del record
 * @property {string} created - Data di creazione del record
 */

/**
 * @typedef {Object} Vaccine
 * @property {number} id - ID del record della vaccinazione
 * @property {string} type - Tipo di vaccino
 */


/**
 * Servizio per gestire le informazioni dei cavalli.
 */
class HorsesVaccineService {

    abortController = null;

    constructor() {
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    /**
     * 
     * @returns {Promise<HorseVaccine[]>}
     * @throws {Error}
     */
    async getHorseVaccines(id, page = 1) {
        try {
            const response = await this.axiosInstance.post('/horse-vaccines/get-vaccines-given-horse-id', {horse_id: id, page});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse vaccines info');
            }

            /** @type {HorseVaccine[]} */
            return response.data.data;
        } catch (error) {
            console.error('Error fetching horse vaccine info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<Vaccine[]>}
     * @throws {Error}
     */
    async getVaccines() {
        try {
            const response = await this.axiosInstance.post('/horse-vaccines/get-vaccines');

            if (response.status !== 200) {
                throw new Error('Failed to fetch vaccines info');
            }

            /** @type {Vaccine[]} */
            return response.data.data.vaccines;
        } catch (error) {
            console.error('Error fetching vaccines info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

     /**
     * 
     * @returns {Promise<HorseVaccine>} - 
     * @throws {Error} - 
     */
     async getHorseVaccineById(id) {
        try {
            const response = await this.axiosInstance.post('/horse-vaccines/get-horse-vaccine-given-id', {horse_vaccine_id: id});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse vaccine info');
            }

            /** @type {HorseVaccine} */
            return response.data.data;
        } catch (error) {
            console.error('Error fetching horse vaccine info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<HorseVaccine>} 
     * @throws {Error} 
     */
    async saveHorseVaccine(data) {
        try {
            
            const response = await this.axiosInstance.post('/horse-vaccines/save-horse-vaccine', data);

            if (response.status !== 200) {
                throw new Error('Failed to save horse vaccine data');
            }

            /** @type {HorseVaccine} */
            return response.data.data.result;
        } catch (error) {
            console.error('Error saving horse vaccine:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }
    
}

export const horsesVaccineService = new HorsesVaccineService();
